import axios from "axios";
import { base_url, base_url_algo, headers } from "../constants";

// ---------- Get stock news
export const getStockNews = async (ticker, page_size) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/news/tickers?tickers=${ticker}&page_size=${page_size}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401) {
      return { success: false, authExpired: true };
    }
    console.error("Get watchlists error:", error);
    return { success: false, error };
  }
};

// ---------- Get stock financials
export const getStockFinancials = async (
  ticker,
  period,
  financial_type
) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const params = new URLSearchParams();

    if (period) {
      params.append("period", period);
    }

    if (financial_type) {
      params.append("financial_type", financial_type);
    }

    const response = await axios.get(
      `${base_url}/api/v1/stocks/financials/${ticker}?${params.toString()}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };

  } catch (error) {
    if (error?.response?.status === 401) {
      return { success: false, authExpired: true };
    }
    console.error("Get stock financials error:", error);
    return { success: false, error };
  }
};

// ---------- Get valuation by ticker
export const getValuationByTicker = async (
  ticker,
  include_history = false
) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/ticker/${ticker}`,
      {
        params: { include_history: false },
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuation by ticker error:", error);
    return { success: false, error };
  }
};

// ---------- Get valuation by stock ID
export const getValuationByStockId = async (stockId) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/stock/${stockId}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuation by stock ID error:", error);
    return { success: false, error };
  }
};

// ---------- Get top-rated stocks
export const getTopRatedValuations = async () => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/top-rated`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get top-rated valuations error:", error);
    return { success: false, error };
  }
};

// ---------- Get valuations by grade
export const getValuationsByGrade = async (grade) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/by-grade/${grade}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      });

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuations by grade error:", error);
    return { success: false, error };
  }
};

// ---------- Get valuation distribution
export const getValuationDistribution = async () => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/distribution`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      });

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuation distribution error:", error);
    return { success: false, error };
  }
};

// ---------- Get valuation history by ticker
export const getValuationHistory = async (ticker) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(
      `${base_url}/api/v1/valuation/history/${ticker}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuation history error:", error);
    return { success: false, error };
  }
};

// ---------- Get earnings calender
export const getEarningsCalendar = async (month, year, code) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(
      `${base_url_algo}/api/earnings/calendar?month=${month}&year=${year}&code=${code}`,
      //   `${base_url_algo}/api/earnings/calendar?month=jan&year=2026&code=sNFAIu2dFIRxj7tNM_coYy5PqrCIAKARu4meea7f7mVUAzFu0KbgDg==`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );
    console.log(response);
    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuation history error:", error);
    return { success: false, error };
  }
};
// https://fa-algo-v2-backend.azurewebsites.net/api/earnings/calendar?month=jan&year=2026&code=sNFAIu2dFIRxj7tNM_coYy5PqrCIAKARu4meea7f7mVUAzFu0KbgDg%3D%3D%27

// ---------- Get Stocks Screener
export const getStocksScreenerQuant = async (params = {}) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  const market = sessionStorage.getItem("selectedMarket") ?? "US";

  try {
    const response = await axios.get(
      `${base_url}/api/v1/stocks/stock-screener/filter`,
      {
        params: { ...params, market_code: market },
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    if (response.data.response_status === "SUCCESS") {
      return { success: true, data: response.data.response_data };
    } else {
      return { success: false, data: [] };
    }
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Stock Screener API - Error:", error);
    return { success: false, error };
  }
};

// ---------- Get Stocks Screener -Ratio Types
export const getStocksScreenerRatioTypes = async (params = {}) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    console.log('Stock Screener API - Calling with params:', params);

    const response = await axios.get(
      `${base_url}/api/v1/stocks/ratio-categories/get`,
      {
        params,
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    console.log('Stock Screener API - Response:', response.data);

    // Extract response_data from the API response
    if (response.data.response_status === "SUCCESS") {
      return {
        success: true,
        data: response.data.response_data
      };
    } else {
      return { success: false, data: [] };
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      return { success: false, authExpired: true };
    }
    console.error('Stock Screener API - Error:', error);
    return { success: false, error };
  }
};

// ---------- Get Factor Ratings
export const getFactorRatings = async (ticker, factor = null) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/stocks/factor-ratings/${ticker}`,
      {
        params: factor ? { factor } : {},
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return {
      success: response.data.response_status === "SUCCESS",
      response_data: response.data.response_data
    };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    return { success: false, error };
  }
};

// ---------- Get Factor Ratings Analysis
export const getFactorRatingsAnalysis = async (payload) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.post(
      `${base_url}/comparison/quant-narrative`,
      payload, // ✅ send full object
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );

    return {
      success: true,
      data: response.data
    };

  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get factor ratings analysis error:", error);
    return { success: false, error };
  }
};


// ---------- Get Earnings Score
export const getEarnings = async (ticker) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/earnings/ticker/${ticker}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    // ✅ Make sure it returns the correct structure
    return {
      success: response.data.response_status === "SUCCESS",
      response_status: response.data.response_status,
      response_data: response.data.response_data
    };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get factor ratings error:", error);
    return { success: false, error };
  }
};

// ---------- Get Price and Percent change
export const getPricePercentChange = async (ticker) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/earnings/api/v1/stocks/${ticker}/quote`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );
    console.log(response);
    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    console.error(`Stock details error (${ticker}):`, error);
    return { success: false, error };
  }
};

// ---------- Get Stock Comparison
export const getStockComparison = async (tickers) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.get(
      `${base_url}/api/v1/stocks/stock-comparisons/get?tickers=${encodeURIComponent(tickers)}`,
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );
    console.log(response);
    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    console.error(`Stock comparison error:`, error);
    return { success: false, error };
  }
};

// ---------- Get Comparison Narattive
export const getComparisonNarrative = async (payload) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  try {
    const response = await axios.post(
      `${base_url}/comparison/analysis`,
      payload, // ✅ proper body
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      }
    );

    return response.status === 200
      ? { success: true, data: response.data }
      : { success: false, data: response.data };
  } catch (error) {
    console.error("Comparison narrative error:", error);
    return { success: false, error };
  }
};

// ---------- Upload Portfolio File
export const uploadPortfolioFile = async (file) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };

  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axios.post(
      `${base_url}/api/v1/portfolios/portfolio-add/file-upload`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    return {
      success: false,
      response_message:
        error?.response?.data?.response_message || "File upload failed",
    };
  }
};

// ---------- Get peers
export const getPeers = async (ticker) => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  const market = sessionStorage.getItem("selectedMarket") ?? "US";

  try {
    const response = await axios.get(
      `${base_url}/api/v1/stocks/sector-wise-top-stocks/${ticker}`,
      {
        // params: { market_code: market },
        headers: {
          ...headers,
          Authorization: `Bearer ${jwtToken}`,
        },
        withCredentials: false,
      });

    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get valuations by grade error:", error);
    return { success: false, error };
  }
};

// ---------- Get market types
export const getMarkets = async () => {
  const jwtToken = sessionStorage.getItem("authToken");
  if (!jwtToken) return { success: false, authExpired: true };
  try {
    const response = await axios.get(`${base_url}/api/v1/markets`, {
      headers: {
        ...headers,
        Authorization: `Bearer ${jwtToken}`,
      },
      withCredentials: false,
    });
    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 401)
      return { success: false, authExpired: true };

    console.error("Get markets error:", error);
    return { success: false, error };
  }
};




